import { get } from "../../utils/object-helpers";

class {
    handleClick(originalEvent) {
        this.emit('click', { originalEvent });
    }
}

<if(input)>
    $ {
        const discoverTextSpan = (obj) => obj?.text && obj?._type === "TextSpan" ? [obj] : [];
        const accessibilityText = get(input, "accessibilityText", "");
        const addLineBreaks = get(input, "addLineBreaks", false);
        const allowHtml = get(input, "allowHtml", false);
        const action = get(input, "action", {});
        const target = get(input, "target", null);
        const wrapper = get(input, "wrapper", null);
        const tabIndex = get(input, "tabindex", null);
        const customCssClasses = get(input, "class", "");
        const spanContainers = get(input, "spanContainers", null);
        const tabIndexAttr = tabIndex ? { tabindex: tabIndex } : null;
        const cssClasses = customCssClasses.length ? { class: customCssClasses } : null;
        const readAccessibilityAndTxt = get(input, "useAccessibilityTxt", false);
        const ariaLabel = !readAccessibilityAndTxt && !accessibilityText.length ? { "aria-label": accessibilityText } : null;
        const tracking = get(action, "trackingList.0");
        const trackingAttr = tracking ? { "data-track": JSON.stringify(tracking) } : null;
        const rawTextSpans = get(input, "textSpans", discoverTextSpan(input));
        const customParser = get(input, "customParser", null);
        const innerActions = !!rawTextSpans.find(textSpan => textSpan.action?.URL);
        const href = action.URL && !innerActions ? { href: action.URL } : null;
        const targetAttr = href && target ? { target } : null;
        const attrs = { ...href, ...targetAttr, ...cssClasses, ...ariaLabel, ...tabIndexAttr, ...trackingAttr };
        const hasWrappingAttrs = rawTextSpans.length > 1 || href || trackingAttr || tabIndexAttr || wrapper;
        const textSpans = rawTextSpans.map(textSpan => {
            if (!accessibilityText.length) {
                return textSpan;
            } else if (!readAccessibilityAndTxt && hasWrappingAttrs) {
                return { ...textSpan, ariaHidden: true };
            } else {
                return { ...textSpan, accessibilityText };
            }
        });
        const container = hasWrappingAttrs ? (href ? "a" : wrapper ? wrapper : "span") : null;
    }

    <${container} ...attrs onClick("handleClick")>
        <str-text-span
            allowHtml=allowHtml
            addLineBreaks=addLineBreaks
            customParser=customParser
            spanContainers=spanContainers
            textSpans=textSpans
            target=target
            ...(!hasWrappingAttrs ? attrs : {})
        />
    </>
</if>
